// Libraries
import React from 'react'
import { ModuleNames } from '../../../constants/componentNames.constants'
import { LocaleCodes } from '../../../constants/localization.constants'
import Layout from '../../layouts/layout'

// New Steam Page Modules
import ContentBlock from '../../global/contentBlock'
import ContentColumns from '../../global/contentColumns'
import ContentRows from '../../global/contentRows'
import Divider from '../../global/divider'
import FeaturedResource from '../../global/featuredResource'
import Grid from '../../global/grid'
import Hero from '../../global/hero'
import Icons from '../../global/icons'
import Image from '../../global/image'
import KeyStats from '../../global/keyStats'
import MainCTA from '../../global/mainCta'
import MediaText from '../../global/mediaText'
import ParagraphBlock from '../../global/paragraphBlock'
import PlatformDiagram from '../../global/platformDiagram'
import Quote from '../../global/quote'
import ResourceLists from '../../global/resourceLists'
import ResourceRow from '../../global/resourceRow'
import ResourceTabs from '../../global/resourceTabs'
import SEOTags from '../../global/seoTags'
import Slider from '../../global/slider'
import Table from '../../global/table'
import Tiles from '../../global/tiles'
import VideoPlayer from '../../global/videoPlayer'
import VideoSpotlight from '../../global/videoSpotlight'

const ProductPage = ({
  path,
  pageContext,
  location,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}: any) => {
  let dynamicPageContent, hero, spotlight, ctaSection, pageData: any
  let pageType: string = ''
  if (pageContext && pageContext.productData) {
    pageData = pageContext.productData
    pageType = 'product'
  } else if (pageContext && pageContext.flexData) {
    pageData = pageContext.flexData
    pageType = 'flex'
  } else if (pageContext && pageContext.solutionsData) {
    pageData = pageContext.solutionsData
    pageType = 'solutions'
  } else if (pageContext && pageContext.aboutRPAData) {
    pageData = pageContext.aboutRPAData
    pageType = 'aboutRPA'
  } else if (pageContext && pageContext.companyListingPageData) {
    pageData = pageContext.companyListingPageData
    pageType = 'companyListing'
  }
  let defaultLocale: string
  if (pageContext && pageContext.pageLocale) {
    defaultLocale = pageContext.pageLocale
  } else {
    defaultLocale = LocaleCodes.ENGLISH.code
  }
  const pageTitle = pageData.name ? pageData.name : ''
  if (pageData && pageData.hero) {
    hero = (
      <Hero
        data={pageData.hero}
        location={location}
        pageTitle={pageTitle}
        showBreadcrumbs={true}
        pageType={pageType}
        locale={defaultLocale}
        breadcrumb={pageData.breadcrumb}
      />
    )
  }

  if (pageData && pageData.spotlight) {
    spotlight = <VideoSpotlight data={pageData.spotlight}></VideoSpotlight>
  }

  if (pageData && pageData.bottomCta) {
    ctaSection = <MainCTA data={pageData.bottomCta}></MainCTA>
  }

  if (pageData && (pageData.flexSection || pageData.modules)) {
    const productPageContent = pageData.flexSection ? pageData.flexSection : pageData.modules
    dynamicPageContent = productPageContent.map((module: any, i: Number) => {
      switch (module.__typename) {
        case ModuleNames.DIVIDER:
          return <Divider data={module} key={`page-component--${i}`}></Divider>

        case ModuleNames.MEDIA_TEXT:
          return <MediaText data={module} key={`page-component--${i}`}></MediaText>
        case ModuleNames.MEDIA_ASSET:
          return (
            <MediaText data={module} mediaAsset={true} key={`page-component--${i}`}></MediaText>
          )

        case ModuleNames.CONTENT_ROWS:
          return <ContentRows data={module} key={`page-component--${i}`} />

        case ModuleNames.GLOBAL_KEY_STATS:
          return <KeyStats data={module} key={`page-component--${i}`}></KeyStats>

        case ModuleNames.VIDEO_SPOTLIGHT:
          return <VideoSpotlight data={module} key={`page-component--${i}`}></VideoSpotlight>

        case ModuleNames.GLOBAL_CONTENT_COLUMNS:
          return <ContentColumns data={module} key={`page-component--${i}`}></ContentColumns>

        case ModuleNames.GLOBAL_CONTENT_BLOCK:
          return <ContentBlock data={module} key={`page-component--${i}`}></ContentBlock>

        case ModuleNames.RESOURCE_ROW:
          return (
            <ResourceRow
              data={module}
              key={`page-component--${i}`}
              locale={defaultLocale}></ResourceRow>
          )

        case ModuleNames.ICONS:
          return <Icons data={module} key={`page-component--${i}`}></Icons>

        case ModuleNames.GRID:
          return <Grid data={module} key={`page-component--${i}`}></Grid>

        case ModuleNames.QUOTE:
          return <Quote data={module} key={`page-component--${i}`}></Quote>

        case ModuleNames.FEATURED_RESOURCE:
          return (
            <FeaturedResource
              data={module}
              pageLocale={defaultLocale}
              key={`page-component--${i}`}></FeaturedResource>
          )

        case ModuleNames.SLIDER:
          return <Slider data={module} key={`page-component--${i}`}></Slider>

        case ModuleNames.TABLE:
          return <Table data={module} key={`page-component--${i}`}></Table>

        case ModuleNames.HERO:
          const pageTitle = pageData.name ? pageData.name : ''
          return (
            <Hero
              data={module}
              location={location}
              pageTitle={pageTitle}
              showBreadcrumbs={true}
              key={`page-component--${i}`}
              pageType={pageType}
              metaInformation={pageData.metaInformation}
              pageUseCase={pageData.pageUseCase}
              locale={defaultLocale}
            />
          )
        case ModuleNames.GLOBAL_MAIN_CTA:
          return <MainCTA data={module} key={`page-component--${i}`}></MainCTA>
        case ModuleNames.VIDEO_SPOTLIGHT:
          return <VideoSpotlight data={module} key={`page-component--${i}`}></VideoSpotlight>

        case ModuleNames.RESOURCE_TABS:
          return <ResourceTabs data={module} key={`page-component--${i}`}></ResourceTabs>

        case ModuleNames.PLATFORM_DIAGRAM:
          return <PlatformDiagram data={module} key={`page-component--${i}`} />

        case ModuleNames.TILES:
          return <Tiles data={module} key={`page-component--${i}`}></Tiles>
        case ModuleNames.WRAPPER_ASSET:
          let imageData = {
            imageFile: {
              file: {
                title: '',
                url: '',
              },
            },
          }
          if (module.altText) {
            imageData.imageFile.file.title = module.altText
          }
          if (module.image && module.image.file && module.image.file.url) {
            imageData.imageFile.file.url = module.image.file.url
          }
          return <Image data={imageData} key={`page-component--${i}`} outerPage={pageType}></Image>
        case ModuleNames.WRAPPER_VIDEO:
          const imgSrc =
            module && module.image && module.image.file && module.image.file.url
              ? module.image.file.url
              : '/'
          const bgAlt = module.altText ? module.altText : ''
          const start = module.start ? module.start : '0'
          let videoId,
            videoUrl: string = '',
            type: string = ''

          if (module.youtubeId) {
            videoId = module.youtubeId
            type = 'youtube'
          }
          if (module.vimeoId) {
            videoId = module.vimeoId
            type = 'vimeo'
          }
          if (module.videoUrl) {
            videoUrl = module.videoUrl
            type = 'html-video'
          }
          if (module.tencentVideoUrl) {
            videoUrl = module.tencentVideoUrl
            type = 'tencent-video'
          }

          if (videoId || videoUrl) {
            return (
              <VideoPlayer
                videoId={videoId}
                videoUrl={videoUrl}
                width={'100%'}
                height={'429'}
                img={imgSrc}
                type={type}
                start={start}
                backgroundAltText={bgAlt}
                key={`page-component--${i}`}
                outerPage={pageType}></VideoPlayer>
            )
          }

        case ModuleNames.PARAGRAPH_BLOCK:
          return <ParagraphBlock data={module} key={`page-component--${i}`} />

        case ModuleNames.ANCHOR_LINK:
          const identifier = module?.identifier ? module.identifier : ''
          return <span key={`page-component--${i}`} id={identifier}></span>

        case ModuleNames.RESOURCE_LISTS:
          return <ResourceLists data={module} />
      }
    })
  }

  const defaultSlug = pageData && pageData.slug ? pageData.slug : '/'
  const seoData = pageData && pageData.seoMetadata ? pageData.seoMetadata : null

  const siteSection = pageType === 'flex' ? 'Flex' : 'Product'
  const pageInner = (
    <div data-cy={`ProductPage--${pageType}`}>
      <SEOTags
        seoMetadata={seoData}
        slug={defaultSlug}
        path={path}
        locale={defaultLocale}
        siteSection={siteSection}
        availableLocales={pageContext.availableLocales}
      />
      {hero}
      {spotlight}
      {dynamicPageContent}
      {ctaSection}
    </div>
  )

  return (
    <Layout.Template
      lang={defaultLocale}
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      mainNavBannerData={mainNavBannerData}
      browserLanguageData={browserLanguageData}
      pageType={pageType}
      slug={defaultSlug}
      availableLocales={pageContext.availableLocales}>
      {pageInner}
    </Layout.Template>
  )
}

export default ProductPage
